import React from "react";
import { useLang } from "@/context/LangContext";
import { MapPin, MessageCircle, Mail, Clock } from "lucide-react";

export default function ContactSection() {
  const { t } = useLang();
  const items = [
    { key: "studio", icon: MapPin, label: t.contact.address_label, value: t.contact.address },
    { key: "wechat", icon: MessageCircle, label: t.contact.wechat_label, value: t.contact.wechat, hint: "ID", recommended: true },
    { key: "line", icon: MessageCircle, label: t.contact.line_label, value: t.contact.line, hint: "ID" },
    { key: "email", icon: Mail, label: t.contact.email_label, value: t.contact.email },
    { key: "hours", icon: Clock, label: t.contact.hours_label, value: t.contact.hours },
  ];
  return (
    <section id="contact" data-testid="contact-section" className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 border-t border-[hsl(var(--border))]">
      <p className="text-xs tracking-[0.25em] text-[hsl(var(--muted-foreground))]">{t.contact.eyebrow}</p>
      <h2 className="font-display text-3xl md:text-5xl tracking-tight font-medium mt-3 max-w-2xl">{t.contact.title}</h2>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {items.map(({ key, icon: Icon, label, value, hint, recommended }) => (
          <div
            key={key}
            data-testid={`contact-${key}`}
            className={`relative rounded-2xl border bg-white p-6 lift ${recommended ? 'border-[hsl(var(--primary))] ring-1 ring-[hsl(var(--primary))]/30' : 'border-[hsl(var(--border))]'}`}
          >
            {recommended && (
              <span data-testid="contact-wechat-recommended" className="absolute -top-2.5 right-4 text-[10px] tracking-[0.2em] uppercase px-2 py-0.5 rounded-full bg-[hsl(var(--primary))] text-white">
                {t.contact.recommended}
              </span>
            )}
            <Icon className="w-5 h-5 text-[hsl(var(--primary))]" />
            <p className="mt-4 text-xs tracking-[0.2em] uppercase text-[hsl(var(--muted-foreground))]">{label}</p>
            <p className="mt-2 text-sm text-[hsl(var(--foreground))] font-medium break-words">
              {hint && <span className="text-[hsl(var(--muted-foreground))] text-xs mr-1.5">{hint}</span>}
              {value}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
